import axios from "axios";
import { serverLink } from "../constants/serverlinks";

const instance = axios.create({
  baseURL: `${serverLink}/api`,
});

export default instance;
